<template>
  <div style="width: 100%">
    <table class="ui striped selectable table">
      <thead>
        <tr>
          <th>#</th>
          <th>Username</th>
          <th v-if="showRole">Role</th>
          <th>Last sign-in date</th>
          <th v-if="showRollNumber">Roll number</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!teachers || teachers.length == 0">
          <td></td>
          <td colspan="4">No Teachers found</td>
        </tr>
        <teacher-table-row
          v-for="teacher in teachers"
          v-bind:teacher="teacher"
          v-bind:showRole="showRole"
          v-bind:key="teacher.Id"
          v-bind:actions="actions"
          v-on:action="rowAction"
          v-bind:showRollNumber="showRollNumber"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import TeacherTableRow from '@/components/teachers/TeacherTableRow';

export default {
  name: 'TeachersTable',
  computed: {},
  components: { TeacherTableRow },
  props: ['teachers', 'actions', 'showRollNumber', 'showRole'],
  methods: {
    rowAction(action) {
      this.$emit('rowAction', action);
    },
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/teachers/TeachersTable.vue